import { createReducer } from '@reduxjs/toolkit';
import { getFeedsThunk } from '../../actions/feeds';
import { Feeds } from '../../types/Endpoints/feeds';

export interface Model {
  feeds: Feeds;
}

export const feeds = createReducer<Model>({
    feeds: [],
}, builder => {
    builder.addCase(getFeedsThunk.fulfilled, (state, { payload }) => ({
        ...state,
        feeds: payload,
    }));
});
